import React, { FC, useRef } from 'react';
import { useTheme } from 'styled-components';
import { useTranslate } from '@/translations';
import { Icons, Title, PageContainer } from '@/ui/components';
import { TransportDataGrid } from './components/TransportMovementDataGrid';

export const TransportMovement: FC = () => {
  const { t } = useTranslate();
  const { transportMovementLink } = useTheme();
  const scroffRef = useRef<HTMLDivElement>(null);
  return (
    <div ref={scroffRef} style={{ height: '100%', overflowY: 'auto' }}>
      <PageContainer>
        <Title
          title={t('transportSummary')}
          icon={Icons.shortTransporter}
          color={transportMovementLink}
        />
        <TransportDataGrid scrollContainerRef={scroffRef} />
      </PageContainer>
    </div>
  );
};
